import React from "react";
import { makeStyles, useTheme, useMediaQuery, Box } from "@material-ui/core";

import Hidden from "@material-ui/core/Hidden";
import TitlePage from "./../../../common/TitlePage";
import Carousel from "react-elastic-carousel";
import { convertNumberToPersian } from "../../../method/convertDigitToEnglish";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    overflow: "hidden",
    marginTop: 90,
  },
  root: {
    width: "60%",
    margin: "0 auto",
    textAlign: "center",
    paddingBottom: 100,
    [theme.breakpoints.down("680")]: {
      width: "95%",
      paddingBottom: 60,
    },
  },
  content: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "auto auto auto auto auto",
    justifyContent: "center",
    marginTop: 60,
    [theme.breakpoints.down("1450")]: {
      gridTemplateColumns: "auto auto auto",
    },
    [theme.breakpoints.down("1000")]: {
      gridTemplateColumns: "auto auto",
      gridGap: "20px 50px",
    },
    [theme.breakpoints.down("600")]: {
      gridTemplateColumns: "auto auto",
      gridGap: "5px 5px",
    },
  },
  box: {
    margin: "10px 10px",
    width: "187px",
    height: "270px",
    background: "#ffffff",
    borderRadius: "15px",
    boxShadow: "0px 0px 36px 0px rgba(0,0,0,0.16)",
    [theme.breakpoints.down("600")]: {
      width: "200px",
    },
    [theme.breakpoints.down("450")]: {
      width: "200px",
      margin: "3px 3px",
    },
  },
  background: {
    position: "absolute",
    left: -30,
    top: 0,
    zIndex: -1,
  },
  btn: {
    width: "90%",
    margin: "0 auto",
    height: "38px",
    border: "1px solid #d1d1d1",
    borderRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  mobileWrap: {
    width: "100%",
    display: "none",
    padding: "0 20px",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  carouselWrap: {
    "& .rec-carousel": {
      maxWidth: "100%",
    },
    "& .rec-slide": {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

export default function SystemTrades() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <TitlePage position="bottomCenter">
          سامانه‌های معاملاتی کارگزاری پویان
        </TitlePage>

        {/* دسکتاپ – همون گرید قبلی */}
        {!isMobile && (
          <Box className={classes.content}>
            {data.map((item, ind) => (
              <Box key={ind} className={classes.box}>
                <a href={item.src2} target="_blank">
                  <img
                    src={`/assets/images/${item.src}`}
                    alt={item.link}
                    className="mt-3"
                  />
                  <p className="mt-4 mb-4">
                    {convertNumberToPersian(item.title)}
                  </p>
                </a>

                <div className="d-flex flex-column">
                  <a href={item.src2} className={classes.btn} target="_blank">
                    {item.link2}
                  </a>
                  <a href={item.src1} download>
                    <span style={{ color: "lightgrey" }}>{item.link}</span>
                  </a>
                </div>
              </Box>
            ))}
          </Box>
        )}

        {/* موبایل – Carousel */}
        {isMobile && (
          <div className={classes.mobileWrap}>
            <div className={classes.carouselWrap}>
              <Carousel
                breakPoints={[{ width: 1, itemsToShow: 1 }]}
                enableAutoPlay
                autoPlaySpeed={2500}
                renderArrow={() => <span style={{ display: "none" }} />}
                renderPagination={() => <span style={{ display: "none" }} />}
                isRTL
              >
                {data.map((item, ind) => (
                  <Box key={ind} className={classes.box}>
                    <a href={item.src2} target="_blank">
                      <img
                        src={`/assets/images/${item.src}`}
                        alt={item.link}
                        className="mt-3"
                      />
                      <p className="mt-4 mb-4">
                        {convertNumberToPersian(item.title)}
                      </p>
                    </a>

                    <div className="d-flex flex-column">
                      <a
                        href={item.src2}
                        className={classes.btn}
                        target="_blank"
                      >
                        {item.link2}
                      </a>
                      <a href={item.src1} download>
                        <span style={{ color: "lightgrey" }}>{item.link}</span>
                      </a>
                    </div>
                  </Box>
                ))}
              </Carousel>
            </div>
          </div>
        )}

        <Hidden smDown>
          <Box className={classes.background}>
            <img src="/assets/images/fade-logo.png" alt="background-pouyan" />
          </Box>
        </Hidden>
      </div>
    </div>
  );
}

const data = [
  {
    title: "آنلاین تدبیر",
    link: "",
    link2: "ورود به سامانه",
    src: "hamrahPlusLogo.svg",
    src1: "",
    src2: "https://online.pouyanbroker.ir/Account/Login",
  },
  {
    title: "آنلاین اکسیر",
    link: "راهنما",
    link2: "ورود به سامانه",
    src: "toturial-trades.svg",
    src1: "/assets/file/راهنمای آنلاین اکسیر.pdf",
    src2: "https://poyan.exirbroker.ir",
  },
  {
    title: "سامانه معاملاتی کمان",
    link: "",
    link2: "ورود به سامانه",
    src: "classic-trades.svg",
    src1: "",
    src2: "https://kaman.pouyanbroker.ir",
  },
  {
    title: "کوین آنلاین",
    link: "",
    link2: "ورود به سامانه",
    src: "classic-trades.svg",
    src1: "",
    src2: "https://coinonline.pouyanbroker.ir",
  },
  {
    title: "آنلاین رایان همراه",
    link: "",
    link2: "ورود به سامانه",
    src: "classic-trades.svg",
    src1: "",
    src2: "https://poyan.exirbroker.ir",
  },
];
